module.exports = __webpack_public_path__ + "media/images/players/STEELE_BRENDAN-b86673661bac5b91f0d876dd90f9c01a.png";